import { Box, Group, Text } from "@mantine/core"
import type { ReactNode } from "react"
import classes from "./wizard.module.css"

/** A numbered wizard card (canvas Ord_RouteWizard): number + title on the left, `aside` right. */
export function WizardSection({
  n,
  title,
  aside,
  children,
}: Readonly<{ n?: number; title: ReactNode; aside?: ReactNode; children: ReactNode }>) {
  return (
    <Box component="section" className={classes.card}>
      <Box className={classes.head}>
        <Group gap="sm" wrap="nowrap" miw={0}>
          {n !== undefined && (
            <Box component="span" className={classes.num}>
              {n}
            </Box>
          )}
          <Text className={classes.title}>{title}</Text>
        </Group>
        {aside}
      </Box>
      <Box className={classes.body}>{children}</Box>
    </Box>
  )
}

/** «● Бөглөгдсөн» and the step lines of the action bar: a dot in the step's tone and its label. */
export function StatusDot({ tone, children }: Readonly<{ tone: "green" | "dark" | "grey"; children: ReactNode }>) {
  return (
    <Text span className={classes.status}>
      <Box component="span" className={classes.dot} data-tone={tone} />
      {children}
    </Text>
  )
}
